<div
    class="h-screen w-[100%] bg-gradient-to-br from-blue-50 via-white to-cyan-50 dark:from-gray-900 dark:via-slate-800 dark:to-gray-900 p-4 overflow-hidden overflow-y-auto">

    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
        <div>
            <h1 class="text-3xl font-extrabold text-blue-800 dark:text-cyan-400 tracking-tight uppercase">Ship Cruise Schedule
            </h1>
        </div>


        <button *ngIf="!isFormView" (click)="openNewForm()"
            class="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-bold py-2 px-6 rounded-xl shadow-lg shadow-blue-500/30 transition-all duration-300 flex items-center gap-2">
            <i class="fa-solid fa-plus"></i> New Cruise Plan
        </button>
    </div>

    <!-- LIST VIEW -->
    <div *ngIf="!isFormView"
        class="bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-xl border border-blue-200 dark:border-cyan-500/20 overflow-hidden">
        <!-- Top toolbar inside panel -->
        <div
            class="p-4 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center bg-gray-50/50 dark:bg-slate-800/50">
            <div class="relative w-64">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <i class="fa-solid fa-search text-gray-400"></i>
                </div>
                <input type="text" [(ngModel)]="searchText"
                    class="bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2 text-gray-900 dark:text-white"
                    placeholder="Search cruises...">
            </div>

            <div class="flex items-center gap-3">
                <select [(ngModel)]="statusFilter"
                    class="bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 text-gray-900 dark:text-white font-medium shadow-sm">
                    <option value="All">All Status</option>
                    <option value="Planned">Planned</option>
                    <option value="Proposed">Proposed</option>
                    <option value="Tentative">Tentative</option>
                    <option value="Completed">Completed</option>
                </select>

                <button (click)="exportToExcel()"
                    class="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-emerald-600 text-white text-[11px] font-black uppercase tracking-widest hover:bg-emerald-700 transition-all shadow-lg shadow-emerald-500/20 active:scale-95">
                    <i class="fa-solid fa-file-excel"></i>
                    <span>Export Excel</span>
                </button>

            </div>
        </div>

        <div class="overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-600 dark:text-gray-300">
                <thead class="text-xs text-gray-700 uppercase bg-blue-50/50 dark:bg-slate-700/50 dark:text-gray-400">
                    <tr>
                        <th scope="col" class="px-6 py-4 rounded-tl-lg font-bold">Cruise ID</th>
                        <th scope="col" class="px-6 py-4 font-bold">Vessel / Project</th>
                        <th scope="col" class="px-6 py-4 font-bold">Dates (Duration)</th>
                        <th scope="col" class="px-6 py-4 font-bold">Area</th>
                        <th scope="col" class="px-6 py-4 font-bold">Status</th>
                        <th scope="col" class="px-6 py-4 rounded-tr-lg font-bold text-center">Actions</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                    <tr *ngFor="let cruise of getFilteredCruises()"
                        class="bg-white dark:bg-slate-800 hover:bg-blue-50/50 dark:hover:bg-slate-700/50 transition-colors group">
                        <td class="px-6 py-4 font-bold text-blue-700 dark:text-cyan-400">
                            {{ cruise.id }}
                        </td>
                        <td class="px-6 py-4">
                            <div class="font-semibold text-gray-900 dark:text-white">{{ cruise.vessel }}</div>
                            <div class="text-xs text-gray-500 dark:text-gray-400">{{ cruise.project }}</div>
                        </td>
                        <td class="px-6 py-4">
                            <div>{{ cruise.startDate | date:'dd-MMM-yyyy' }} to {{ cruise.endDate | date:'dd-MMM-yyyy'
                                }}</div>
                            <div class="text-xs text-blue-600 dark:text-cyan-400 font-medium mt-0.5">{{ cruise.duration
                                }} Days</div>
                        </td>
                        <td class="px-6 py-4">
                            <div>{{ cruise.studyArea }}</div>
                            <div class="text-xs text-gray-500 dark:text-gray-400"><i
                                    class="fa-solid fa-location-dot mr-1 text-red-400"></i>{{
                                cruise.departurePort }} - {{
                                cruise.arrivalPort }}</div>
                        </td>
                        <td class="px-6 py-4">
                            <span class="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border border-green-200 dark:border-green-800': cruise.status === 'Completed',
                  'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 border border-blue-200 dark:border-blue-800': cruise.status === 'Planned',
                  'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border border-amber-200 dark:border-amber-800': cruise.status === 'Proposed' || cruise.status === 'Tentative'
                }">
                                {{ cruise.status }}
                            </span>
                        </td>
                        <td class="px-6 py-4 text-center space-x-2">
                            <button (click)="editCruise(cruise)"
                                class="text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-cyan-400 transition-colors p-2 rounded-lg hover:bg-blue-100 dark:hover:bg-slate-700">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="getFilteredCruises().length === 0">
                        <td colspan="6" class="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
                            <div class="flex flex-col items-center justify-center">
                                <i class="fa-solid fa-ship text-4xl mb-3 text-gray-300 dark:text-gray-600"></i>
                                <p class="text-lg font-medium">No cruise schedules found</p>
                                <p class="text-sm mt-1">Create a new plan to get started.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- FORM VIEW -->
    <div *ngIf="isFormView" class="flex flex-col gap-6 lg:flex-row h-[calc(100vh-120px)]">

        <!-- Left Panel: Form Details -->
        <div class="w-full lg:w-[60%] flex flex-col gap-4 overflow-y-auto pr-2 pb-10 custom-scrollbar">
            <form [formGroup]="cruiseForm">

                <!-- Primary Details Card -->
                <div
                    class="bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-lg border border-blue-200 dark:border-cyan-500/20 p-6 mb-4">
                    <h2
                        class="text-lg font-bold text-gray-800 dark:text-white mb-4 border-b border-gray-200 dark:border-slate-700 pb-2">
                        <i class="fa-solid fa-circle-info text-blue-500 mr-2"></i> Cruise Details
                    </h2>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <!-- Cruise ID -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Cruise ID
                                *</label>
                            <input formControlName="id" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>

                        <!-- Vessel -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Research Vessel
                                *</label>
                            <input formControlName="vessel" list="vessels-list"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white"
                                placeholder="Type or select vessel">
                            <datalist id="vessels-list">
                                <option value="RV Sagar Manjusha"></option>
                                <option value="RV Sindhu Sadhana"></option>
                                <option value="ORV Sagar Kanya"></option>
                            </datalist>
                        </div>
                        <!-- Status -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Status
                                *</label>
                            <select formControlName="status"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                                <option value="Proposed">Proposed</option>
                                <option value="Planned">Planned</option>
                                <option value="Tentative">Tentative</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </div>

                        <!-- Project -->
                        <div class="lg:col-span-2">
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Project /
                                Mission *</label>
                            <input formControlName="project" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>

                        <!-- Chief Scientist -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Chief Scientist
                                *</label>
                            <input formControlName="chiefScientist" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>

                        <!-- Dates -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Start Date
                                *</label>
                            <input formControlName="startDate" type="date"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white [color-scheme:light] dark:[color-scheme:dark]">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">End Date
                                *</label>
                            <input formControlName="endDate" type="date"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white [color-scheme:light] dark:[color-scheme:dark]">
                        </div>
                        <!-- Duration -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Duration (Days)
                                *</label>
                            <input formControlName="duration" type="number" min="1" readonly tabindex="-1"
                                class="w-full bg-gray-100 dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-700 dark:text-gray-400 cursor-not-allowed">
                        </div>

                        <!-- Ports and Area -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Departure Port
                                *</label>
                            <input formControlName="departurePort" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Arrival Port
                                *</label>
                            <input formControlName="arrivalPort" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>
                        <div class="lg:col-span-1">
                            <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Study Area
                                *</label>
                            <input formControlName="studyArea" type="text"
                                class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white">
                        </div>

                        <!-- Plan & Equipment -->
                        <div class="lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Sample
                                    Collection Plan</label>
                                <textarea formControlName="samplePlan" rows="2"
                                    class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white"></textarea>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Equipment
                                    Used</label>
                                <textarea formControlName="equipment" rows="2"
                                    class="w-full bg-gray-50 dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 text-gray-900 dark:text-white"
                                    placeholder="e.g. CTD, ADCP, Plankton Net"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Dynamic Station Planner -->
                <div
                    class="bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-lg border border-blue-200 dark:border-cyan-500/20 p-6">
                    <div
                        class="flex justify-between items-center mb-4 border-b border-gray-200 dark:border-slate-700 pb-2">
                        <h2 class="text-lg font-bold text-gray-800 dark:text-white">
                            <i class="fa-solid fa-map-location-dot text-cyan-500 mr-2"></i> Route Station Planner
                        </h2>
                        <button type="button" (click)="addStation()"
                            class="text-sm bg-blue-100 hover:bg-blue-200 text-blue-700 dark:bg-cyan-900/30 dark:hover:bg-cyan-800/50 dark:text-cyan-400 font-semibold py-1.5 px-3 rounded-lg transition-colors flex items-center gap-1">
                            <i class="fa-solid fa-plus text-xs"></i> Add Station
                        </button>
                    </div>

                    <!-- FormArray iterations -->
                    <div formArrayName="stations" class="space-y-4">
                        <div *ngFor="let stationGroup of stations.controls; let i = index" [formGroupName]="i"
                            class="relative p-4 bg-gray-50 dark:bg-slate-700/50 border border-gray-200 dark:border-slate-600 rounded-xl group hover:border-blue-300 dark:hover:border-cyan-500/50 transition-colors">

                            <!-- Remove Btn (hidden if only 1 item left) -->
                            <button *ngIf="stations.length > 1" type="button" (click)="removeStation(i)"
                                class="absolute -top-2 -right-2 bg-red-100 text-red-600 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-200 dark:bg-red-900/50 dark:text-red-400 dark:hover:bg-red-800 transition-colors opacity-0 group-hover:opacity-100 z-10 transition-opacity">
                                <i class="fa-solid fa-times text-xs"></i>
                            </button>

                            <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                                <div class="md:col-span-1">
                                    <label class="block text-xs font-bold text-gray-600 dark:text-gray-400 mb-1">Station
                                        Name</label>
                                    <input formControlName="name" type="text"
                                        class="w-full bg-white dark:bg-slate-800 border-none shadow-sm text-sm rounded-md focus:ring-blue-500 block p-2 text-gray-900 dark:text-white">
                                </div>
                                <div>
                                    <label
                                        class="block text-xs font-bold text-gray-600 dark:text-gray-400 mb-1">Latitude
                                        (N/S)</label>
                                    <input formControlName="latitude" type="number" step="0.0001"
                                        class="w-full bg-white dark:bg-slate-800 border-none shadow-sm text-sm rounded-md focus:ring-blue-500 block p-2 text-gray-900 dark:text-white"
                                        placeholder="e.g. 10.20">
                                </div>
                                <div>
                                    <label
                                        class="block text-xs font-bold text-gray-600 dark:text-gray-400 mb-1">Longitude
                                        (E/W)</label>
                                    <input formControlName="longitude" type="number" step="0.0001"
                                        class="w-full bg-white dark:bg-slate-800 border-none shadow-sm text-sm rounded-md focus:ring-blue-500 block p-2 text-gray-900 dark:text-white"
                                        placeholder="e.g. 75.50">
                                </div>
                                <div class="md:col-span-1">
                                    <label
                                        class="block text-xs font-bold text-gray-600 dark:text-gray-400 mb-1">Activity</label>
                                    <input formControlName="activity" type="text"
                                        class="w-full bg-white dark:bg-slate-800 border-none shadow-sm text-sm rounded-md focus:ring-blue-500 block p-2 text-gray-900 dark:text-white"
                                        placeholder="CTD, Grab...">
                                </div>
                            </div>
                        </div>

                        <div *ngIf="stations.length === 0"
                            class="text-center py-6 text-gray-500 dark:text-gray-400 italic text-sm">
                            No stations defined. Click "Add Station" to start planning the route.
                        </div>
                    </div>
                </div>

            </form>
        </div>

        <!-- Right Panel: Map & Status -->
        <div class="w-full lg:w-[40%] flex flex-col gap-4">

            <!-- Actions Card -->
            <div
                class="bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-lg border border-blue-200 dark:border-cyan-500/20 p-4 flex justify-end gap-3 shrink-0">
                <button type="button" (click)="cancelForm()"
                    class="px-5 py-2 text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 dark:text-slate-300 dark:bg-slate-700 dark:hover:bg-slate-600 rounded-xl transition-colors">
                    Cancel
                </button>
                <button type="button" (click)="saveCruise()" [disabled]="cruiseForm.invalid"
                    class="px-5 py-2 text-sm font-bold text-white bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 rounded-xl shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                    <i class="fa-solid fa-save mr-1"></i> Save Cruise
                </button>
            </div>

            <!-- Live Route Map Container -->
            <div
                class="h-[68%] bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-xl border border-blue-200 dark:border-cyan-500/20 p-1 relative overflow-hidden flex flex-col min-h-[400px]">
                <div class="absolute top-4 left-4 right-4 z-10 flex justify-between pointer-events-none">
                    <div
                        class="bg-white/95 dark:bg-slate-900/90 backdrop-blur shadow-lg border border-blue-200 dark:border-cyan-500/30 px-3 py-1.5 rounded-lg pointer-events-auto">
                        <span class="text-xs font-bold text-blue-800 dark:text-cyan-400 uppercase tracking-widest"><i
                                class="fa-solid fa-route mr-1"></i> Live Route Planner</span>
                    </div>
                </div>

                <!-- Extracted map component to visualize dynamic array -->
                <!-- Note: We must adjust map.ts to process routeCoordinates input. -->
                <app-map [routeCoordinates]="routeCoordinates"
                    class="w-full h-full block rounded-xl overflow-hidden"></app-map>
            </div>

            <!-- Route Sequence Text -->
            <div
                class="bg-blue-50 dark:bg-cyan-900/20 border border-blue-100 dark:border-cyan-800/30 rounded-xl p-4 shrink-0">
                <h3 class="text-xs font-bold text-blue-700 dark:text-cyan-400 uppercase mb-2">Planned Route Sequence
                </h3>
                <p class="text-sm font-medium text-gray-800 dark:text-slate-200 leading-relaxed break-words">
                    {{ getRouteSequenceString() }}
                </p>
            </div>

        </div>

    </div>

</div>